var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.44 2.561a1.498 1.498 0 010-2.12 1.497 1.497 0 012.121 0L7 4.88 11.439.44a1.497 1.497 0 012.12 0 1.498 1.498 0 010 2.121l-4.438 4.44 4.439 4.439A1.498 1.498 0 0112.5 14c-.385 0-.77-.148-1.061-.439L7 9.121l-4.439 4.44a1.498 1.498 0 01-2.12 0 1.498 1.498 0 010-2.121L4.878 7 .44 2.562z",
    fill: "var(--iconColorPrimary, #10B0AA)"
  })));
}
export default SvgCross;